document.addEventListener('DOMContentLoaded', function () {
  const config = window.BAB_CONFIG || {};

  const state = {
    pack: 'dozen',
    selectedItems: {}
  };

  const els = {
    cards: document.querySelectorAll('.bab-card'),
    packButtons: document.querySelectorAll('.bab-pack'),
    floatCount: document.getElementById('babFloatCount'),
    floatMax: document.getElementById('babFloatMax'),
    floatPrice: document.getElementById('babFloatPrice'),
    floatBtn: document.getElementById('babFloatBtn'),

    flavorModal: document.getElementById('babFlavorModal'),
    modalImg: document.getElementById('babModalImg'),
    modalTitle: document.getElementById('babModalTitle'),
    modalDesc: document.getElementById('babModalDesc'),
    modalIngredients: document.getElementById('babModalIngredients'),
    modalAllergens: document.getElementById('babModalAllergens'),
    modalNutritionLabel: document.getElementById('babModalNFacts'),

    completeModal: document.getElementById('babCompleteModal'),
    completeCount: document.getElementById('babCompleteCount'),
    completePack: document.getElementById('babCompletePack'),
    completeSummary: document.getElementById('babCompleteSummary'),
    editBtn: document.getElementById('babEditBtn'),
    confirmBtn: document.getElementById('babConfirmBtn'),

    successModal: document.getElementById('babSuccessModal'),
    successSummary: document.getElementById('babSuccessSummary'),
    continueBtn: document.getElementById('babContinueBtn')
  };

  function getPackSettings(pack) {
    if (pack === 'half') {
      return {
        max: 6,
        price: Number(config.halfPrice || 0),
        variantId: config.halfVariantId,
        label: 'Half Dozen'
      };
    }

    return {
      max: 12,
      price: Number(config.dozenPrice || 0),
      variantId: config.dozenVariantId,
      label: 'One Dozen'
    };
  }

  function getTotalSelected() {
    return Object.values(state.selectedItems).reduce((sum, item) => sum + item.qty, 0);
  }

  function getSelectedItems() {
    return Object.values(state.selectedItems).filter(item => item.qty > 0);
  }

  function getSelectedFlavors() {
    return getSelectedItems()
      .map(item => `${item.title} x${item.qty}`)
      .join(', ');
  }

  function getSelectedSkus() {
    return getSelectedItems()
      .map(item => `${item.sku || 'NO-SKU'} x${item.qty}`)
      .join(', ');
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function getSummaryHtml() {
    const items = getSelectedItems();

    if (!items.length) {
      return '';
    }

    return `
      <ul style="margin:0; padding-left:18px; text-align:left;">
        ${items.map(item => `<li>${escapeHtml(item.title)} (${escapeHtml(item.sku || 'NO-SKU')}) x${item.qty}</li>`).join('')}
      </ul>
    `;
  }

  function updateUI() {
    const total = getTotalSelected();
    const packSettings = getPackSettings(state.pack);

    if (els.floatCount) els.floatCount.textContent = total;
    if (els.floatMax) els.floatMax.textContent = packSettings.max;
    if (els.floatPrice) els.floatPrice.textContent = `$${packSettings.price.toFixed(2)}`;
    if (els.floatBtn) els.floatBtn.disabled = total !== packSettings.max;

    els.cards.forEach(card => {
      const productId = card.dataset.id;
      const item = state.selectedItems[productId];
      const qty = item ? item.qty : 0;

      const qtyNum = card.querySelector('.bab-card__qty-num');
      const minusBtn = card.querySelector('.bab-card__qty-btn--minus');
      const plusBtn = card.querySelector('.bab-card__qty-btn--plus');
      const badgeQty = card.querySelector('.bab-card__badge-qty');

      if (qtyNum) qtyNum.textContent = qty;
      if (badgeQty) badgeQty.textContent = qty;
      if (minusBtn) minusBtn.disabled = qty < 1;
      if (plusBtn) plusBtn.disabled = total >= packSettings.max && qty === 0;
    });
  }

  function openModal(modal) {
    if (!modal) return;

    modal.hidden = false;
    modal.classList.add('is-open', 'is-active', 'active');
    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden', 'false');

    const dialog = modal.querySelector('[role="dialog"], .bab-modal__box');
    if (dialog) dialog.focus();

    document.body.style.overflow = 'hidden';
    document.body.classList.add('overflow-hidden');
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.classList.remove('is-open', 'is-active', 'active');
    modal.style.display = '';
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;

    document.body.style.overflow = '';
    document.body.classList.remove('overflow-hidden');
  }

  function closeAllModals() {
    document.querySelectorAll('.bab-modal').forEach(modal => {
      modal.classList.remove('is-open', 'is-active', 'active');
      modal.style.display = '';
      modal.setAttribute('aria-hidden', 'true');
      modal.hidden = true;
    });

    document.body.style.overflow = '';
    document.body.classList.remove('overflow-hidden');
  }

  function showCompleteModal() {
    const packSettings = getPackSettings(state.pack);

    if (els.completeCount) els.completeCount.textContent = packSettings.max;
    if (els.completePack) els.completePack.textContent = packSettings.label;
    if (els.completeSummary) els.completeSummary.innerHTML = getSummaryHtml();

    closeModal(els.flavorModal);
    closeModal(els.successModal);
    openModal(els.completeModal);
  }

  function showSuccessModal() {
    if (els.successSummary) {
      els.successSummary.innerHTML = getSummaryHtml();
    }

    closeModal(els.completeModal);
    openModal(els.successModal);
  }

  async function addToCart() {
    const packSettings = getPackSettings(state.pack);

    if (!packSettings.variantId || isNaN(Number(packSettings.variantId))) {
      alert('Product not configured. Please contact support.');
      return;
    }

    const payload = {
      items: [
        {
          id: Number(packSettings.variantId),
          quantity: 1,
          properties: {
            'Selected Flavors': getSelectedFlavors(),
            '_internal_skus': getSelectedSkus()
          }
        }
      ]
    };

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      let errorMessage = 'Failed to add to cart';

      try {
        const errorData = await response.json();
        errorMessage = errorData.description || errorData.message || errorMessage;
      } catch (e) {}

      throw new Error(errorMessage);
    }

    return await response.json();
  }

  function changePack(pack) {
    state.pack = pack;

    els.packButtons.forEach(btn => {
      const active = btn.dataset.pack === pack;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    Object.keys(state.selectedItems).forEach(key => {
      state.selectedItems[key].qty = 0;
    });

    updateUI();
  }

  function openFlavorModal(productId) {
    const card = document.querySelector(`.bab-card[data-id="${productId}"]`);
    if (!card) return;

    const dataEl = card.querySelector('.bab-card__data');
    if (!dataEl) return;

    let productData;
    try {
      productData = JSON.parse(dataEl.textContent);
    } catch (error) {
      console.error('Invalid product JSON', error);
      return;
    }

    if (els.modalImg) {
      els.modalImg.src = productData.image || '';
      els.modalImg.alt = productData.title ? `${productData.title} cookie` : '';
    }

    if (els.modalTitle) els.modalTitle.textContent = productData.title || '';
    if (els.modalDesc) {
      els.modalDesc.textContent = productData.description || 'Delicious handcrafted cookie baked fresh daily.';
    }
    if (els.modalIngredients) els.modalIngredients.textContent = productData.ingredients || '';
    if (els.modalAllergens) els.modalAllergens.textContent = productData.allergens || '';

    if (els.modalNutritionLabel) {
      const hiddenWrap = document.getElementById(`babHiddenNutrition-${productData.id}`);
      els.modalNutritionLabel.innerHTML = '';

      if (!hiddenWrap) {
        els.modalNutritionLabel.innerHTML = '<p style="color:#999;">No nutrition data available.</p>';
      } else {
        const inner = hiddenWrap.querySelector('.bab-hidden-nutrition__inner');

        if (inner) {
          const clone = inner.cloneNode(true);
          els.modalNutritionLabel.appendChild(clone);

          clone.querySelectorAll('script').forEach((oldScript) => {
            const newScript = document.createElement('script');
            Array.from(oldScript.attributes).forEach(attr => {
              newScript.setAttribute(attr.name, attr.value);
            });
            newScript.text = oldScript.text;
            oldScript.parentNode.replaceChild(newScript, oldScript);
          });
        } else {
          els.modalNutritionLabel.innerHTML = '<p style="color:#999;">Nutrition label is still loading.</p>';
        }
      }
    }

    openModal(els.flavorModal);
  }

  els.cards.forEach(card => {
    const productId = card.dataset.id;
    const dataEl = card.querySelector('.bab-card__data');
    if (!dataEl) return;

    let productData;
    try {
      productData = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    state.selectedItems[productId] = {
      id: productData.id,
      variant_id: productData.variant_id || null,
      sku: productData.sku || '',
      title: productData.title || 'Cookie',
      qty: 0
    };

    const plusBtn = card.querySelector('.bab-card__qty-btn--plus');
    const minusBtn = card.querySelector('.bab-card__qty-btn--minus');
    const flavorBtn = card.querySelector('.bab-card__flavor-btn');

    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        const total = getTotalSelected();
        const packSettings = getPackSettings(state.pack);
        const item = state.selectedItems[productId];

        if (total >= packSettings.max) return;

        item.qty += 1;
        updateUI();

        if (getTotalSelected() >= packSettings.max) {
          showCompleteModal();
        }
      });
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        const item = state.selectedItems[productId];
        if (item.qty <= 0) return;

        item.qty -= 1;
        updateUI();
      });
    }

    if (flavorBtn) {
      flavorBtn.addEventListener('click', function () {
        openFlavorModal(productId);
      });
    }
  });

  els.packButtons.forEach(btn => {
    btn.addEventListener('click', function () {
      changePack(btn.dataset.pack);
    });
  });

  if (els.floatBtn) {
    els.floatBtn.addEventListener('click', function () {
      const total = getTotalSelected();
      const packSettings = getPackSettings(state.pack);

      if (total >= packSettings.max) {
        showCompleteModal();
      }
    });
  }

  if (els.confirmBtn) {
    els.confirmBtn.addEventListener('click', async function () {
      if (els.confirmBtn.classList.contains('is-loading')) return;

      try {
        els.confirmBtn.classList.add('is-loading');
        if (els.floatBtn) els.floatBtn.classList.add('is-loading');

        await addToCart();
        showSuccessModal();
      } catch (error) {
        console.error(error);
        alert(error.message || 'There was an error adding your box to cart.');
      } finally {
        els.confirmBtn.classList.remove('is-loading');
        if (els.floatBtn) els.floatBtn.classList.remove('is-loading');
      }
    });
  }

  if (els.editBtn) {
    els.editBtn.addEventListener('click', function () {
      closeModal(els.completeModal);
    });
  }

  if (els.continueBtn) {
    els.continueBtn.addEventListener('click', function () {
      closeModal(els.successModal);
    });
  }

  document.querySelectorAll('.bab-modal').forEach(modal => {
    const overlay = modal.querySelector('.bab-modal__overlay');
    const closeBtn = modal.querySelector('.bab-modal__close');

    if (overlay) {
      overlay.addEventListener('click', function () {
        closeModal(modal);
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeModal(modal);
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeAllModals();
    }
  });

  updateUI();
});